module.exports = __webpack_public_path__ + "img/hamza.e5decef6.jpg";